// Text only. Track must come from the official session, never the selected tab.
export function sharePostText(score, { live = false, verified = false } = {}) {
  if (!Number.isSafeInteger(score) || score < 0) throw new Error('共有記録が無効です');
  if (live && !verified) throw new Error('ライブ記録の受理を確認できません');
  return `AXIOMで${score}桁に到達！${live ? '視聴者と一緒に挑戦。' : ''}${verified ? '' : '個人記録（ランキング未認定）。'} この記録を超えられる？ #AXIOM`;
}

export function sharePostContent(url, score, context) {
  const parsed = new URL(url);
  if (parsed.protocol !== 'https:' && !(parsed.protocol === 'http:' && ['localhost', '127.0.0.1'].includes(parsed.hostname))) throw new Error('共有URLが無効です');
  return `${sharePostText(score, context)}\n${parsed.href}`;
}
